<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/invoice-apply/table">开票管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <template v-if="showErrorMsg">
      <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
    </template>
    <template v-else>
    <layout-panel>
      <span slot="header">开票申请（一次开票申请仅对应一张发票）</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="开票类别"
                          prop="type">
              <el-select v-model="form.issued_type"
                         class="width-max"
                         clearable
                         @change="changeIssuedType"
                         placeholder="请选择">
                <el-option
                  v-for="item in options.issued_type"
                  :key="item.value"
                  :label="item.label"
                  :value="Number(item.value)">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请描述"
                          prop="desc">
              <el-input v-model="form.desc"
                        placeholder="请输入申请描述"></el-input>
            </el-form-item>
            <el-form-item label="BD"
                          v-if="isPreReceived"
                          prop="bd">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入管理员名称搜索"
                v-model="form.bd"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1}))"
                :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="BO审批"
                          prop="bu_approver">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入管理员名称搜索"
                v-model="form.bu_approver"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="抄送人"
                          prop="cc">
              <remote-select
                class="width-max"
                clearable
                multiple
                :multiple-limit=multipleLimit
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入管理员名称搜索"
                v-model="form.cc"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>
            <el-tooltip class="item"
                        effect="dark"
                        content="填写开票注意的事项，如：单位、单价、按含税或未税金额开等事项"
                        placement="right">
              <el-form-item label="开票备注"
                            prop="memo">
                <el-input v-model="form.memo"
                          placeholder="输入开票需要的备注的内容"></el-input>
              </el-form-item>
            </el-tooltip>

            <el-form-item label="添加附件"
                          prop="attached_file">
              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-change="(file, fileList) => {onChangeFile(file, fileList, this.form.attached_file)}"
                :before-remove="(file, fileList) => {beforeRemove(file, fileList, this.form.attached_file)}"
                multiple
                :limit="20"
                :on-exceed="(file, fileList) => {handleExceed(file, fileList, 20)}"
                :file-list="fileList"
                ref="upload"
                accept=".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .doc, .docx, .xls, .xlsx, .ofd, .xml, .zip"
              >
                <el-tooltip class="item"
                            effect="dark"
                            content="附件上传确认开票的资料，有po单的需上传相应的po单"
                            placement="right">
                  <el-button size="small"
                             type="primary">点击上传
                  </el-button>
                </el-tooltip>
                <div slot="tip"
                     class="el-upload__tip">请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/OFD/XML/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="客户名称"
                          prop="customerid">
              <remote-select
                class="width-max"
                clearable
                id-key="number"
                label-key="name"
                value-key="id"
                placeholder="请输入客户名称/编号搜索"
                v-model="form.customerid"
                @change="onChangeCustomerId"
                :query-request="(_)=>getCustomerTable(Object.assign(_, {type: 'all'}))"
                :find-request="getCustomerDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="抬头"
                          prop="receipt_info_id">
              <el-select v-model="form.receipt_info_id"
                         class="width-max"
                         @change="() => form.pay_condition_id = null"
                         clearable
                         placeholder="请选择">
                <el-option
                  v-for="item in receiptOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="receipt-info-block" v-if="receiptInfo">
              <h3>客户开票信息</h3>
              <span class="receipt-info"><span class="receipt-info-text">公司名称: </span>{{ receiptInfo.company_name }}</span>
              <span class="receipt-info"><span class="receipt-info-text">开户行及账号: </span>{{ receiptInfo.bank_info }}</span>
              <span class="receipt-info"><span class="receipt-info-text">地址及电话: </span>{{ receiptInfo.address_phone }}</span>
              <span class="receipt-info"><span class="receipt-info-text">税号: </span>{{ receiptInfo.tax_number }}</span>
            </div>
            <el-form-item label="账期" prop="pay_condition_id">
              <el-select v-model="form.pay_condition_id"
                         class="width-max"
                         clearable
                         placeholder="客户合同约定的回款账期">
                <el-option
                  v-for="item in collectConditionOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发票类别"
                          prop="type">
              <el-select v-model="form.type"
                         class="width-max"
                         clearable
                         placeholder="请选择">
                <el-option
                  v-for="item in options.type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票主体"
                          prop="subject">
              <el-select v-model="form.subject"
                         class="width-max"
                         clearable
                         placeholder="请选择"
                         @change="subjectErrorMessage = ''">
                <el-option
                  v-for="item in availableSubjects"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <div v-if="subjectErrorMessage" style="color: #F56C6C; font-size: 12px; margin-top: 3px; line-height: 1; padding: 2px 0; white-space: nowrap; width: 100%;">
                {{ subjectErrorMessage }}
              </div>
            </el-form-item>
            <el-form-item label="开票金额依据"
                          prop="invoice_tax_type">
              <el-select v-model="form.invoice_tax_type"
                         class="width-max"
                         clearable
                         placeholder="请选择">
                <el-option
                  v-for="item in options.tax_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发票备注"
                          prop="invoice_remark">
              <el-input placeholder="此备注为发票右下角备注信息！！！"
                        v-model="form.invoice_remark"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div>
        <!--   预收款发票隐藏此按钮，不允许添加多条项目 -->
        <el-button type="danger"
                   size="mini"
                   v-if="!isPreReceived"
                   @click="onAddDetail()"
                   style="margin-left:30px; margin-bottom: 30px">添加
        </el-button>
        <el-row>
          <el-col :span="1" class="col-center">序号</el-col>
          <el-col :span="2" class="col-center">开票类型</el-col>
          <el-col :span="2" class="col-center">项目名称/编号</el-col>
          <el-col :span="1" class="col-center">项目完成率 %</el-col>
          <el-col :span="2" class="col-center">DO/PO单号</el-col>
          <el-col :span="2" class="col-center">项目预算</el-col>
          <el-col :span="2" class="col-center">项目成本</el-col>
          <el-col :span="1" class="col-center">规格型号</el-col>
          <el-col :span="1" class="col-center">单位</el-col>
          <el-col :span="1" class="col-center">数量</el-col>
          <el-col :span="2" class="col-center">开票名称</el-col>
          <el-col :span="1" class="col-center">未税金额</el-col>
          <el-col :span="1" class="col-center">税率 %</el-col>
          <el-col :span="1" class="col-center">税额</el-col>
          <el-col :span="1" class="col-center">价税合计</el-col>
        </el-row>
        <br/>
        <el-row v-for="(detailItem, itemIndex) in form.detail"
                :key="itemIndex"
                class="invoice-row"
                style="margin-top:5px">
          <!--序号-->
          <el-col style="text-align: center" :span="1">
            {{itemIndex+1}}
          </el-col>

          <!--开票类型-->
          <el-col :span="2">
            <el-input v-model="detailItem.type" placeholder="请输入"></el-input>
          </el-col>

          <!--普通开票查询客户项目,预收款开票查询虚拟项目编号-->
          <el-col v-if="!isPreReceived" key="project_id"
            :span="2">
            <remote-select
              class="width-max"
              clearable
              id-key="number"
              label-key="name"
              value-key="id"
              placeholder="请输入项目名称/编号搜索"
              v-model="detailItem.projectid"
              @change="changeProject(detailItem.projectid, itemIndex)"
              :disabled="!form.customerid"
              :query-request="(_)=>getProjectTable(Object.assign({customerid: form.customerid, status: statusEnum.ACHIEVEMENT}, _))"
              :find-request="getProjectDetail">
            </remote-select>
          </el-col>
          <el-col v-if="isPreReceived" key="virtual_project_id"
            :span="2">
            <remote-select
              ref="virtual"
              class="width-max"
              clearable
              id-key="number"
              label-key="name"
              value-key="id"
              placeholder="请输入虚拟项目名称/编号搜索"
              v-model="detailItem.virtual_project_id"
              :disabled="!form.customerid"
              :query-request="(_)=>getReceiptVirtualProjectTable(Object.assign({customerid: form.customerid, append_new_info: true}, _))"
              :find-request="getRemoteSelectVirtualProjectInfo">
            </remote-select>
          </el-col>

          <!--项目完成率-->
          <el-col :span="1">
            <el-input v-if="detailItem.modifyRate"
                      v-model="detailItem.complete_rate"
                      :disabled="isPreReceived"
                      placeholder="项目完成率"></el-input>
            <span v-if="!detailItem.modifyRate"
                  style="text-align: center">{{ detailItem.complete_rate }}</span>
          </el-col>

          <!--DO单号-->
          <el-col :span="2">
            <el-input v-model="detailItem.do_number"
                      :disabled="isPreReceived"
                      placeholder="请输入"></el-input>
          </el-col>
          <!--项目预算-->
          <el-col :span="2"
                  style="text-align:center;overflow: auto;">
            <span>{{ symbol }}{{ detailItem.budget | seperateThousandsToFixed(2) }}</span>
          </el-col>
          <!--项目成本-->
          <el-col :span="2"
                  style="text-align:center;overflow: auto;">
            <span>{{ symbol }}{{ detailItem.cost | seperateThousandsToFixed(2) }}</span>
          </el-col>
          <!-- 规格型号 -->
          <el-col :span="1">
            <el-input v-model="detailItem.spec"
                      placeholder="请输入"></el-input>
          </el-col>
          <!-- 单位 -->
          <el-col :span="1">
            <el-input v-model="detailItem.unit"
                      placeholder="请输入"></el-input>
          </el-col>
          <!-- 数量 -->
          <el-col :span="1">
            <el-input v-model="detailItem.quantity"
                      placeholder="请输入"></el-input>
          </el-col>
          <!--开票名称-->
          <el-col :span="2">
            <el-select v-model="detailItem.cost_type"
                       @change="id => changeCostType(id, itemIndex)"
                       placeholder="请选择">
              <el-option
                v-for="item in costTypeOptions"
                :key="item.id"
                :label="item.full_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <!--未税金额-->
          <el-col :span="1">
            <el-input v-model="detailItem.untaxed_amount"
                      placeholder="请输入"
                      @input="computeTotal(itemIndex, detailItem.tax_rate, detailItem.untaxed_amount)"
                      :disabled="!form.invoice_tax_type || form.invoice_tax_type === 1"
            ></el-input>
          </el-col>
          <!--税率-->
          <el-col :span="1">
            <span>{{ detailItem.tax_rate }}</span>
          </el-col>
          <!-- 税额 -->
          <el-col :span="1">
            <span>{{ (detailItem.total - detailItem.untaxed_amount) | seperateThousandsToFixed(2) }}</span>
          </el-col>
          <!--价税合计-->
          <el-col :span="1"
                  style="text-align:center">
            <el-input v-model="detailItem.total"
                      placeholder="请输入"
                      @input="computeUntaxedAmount(itemIndex, detailItem.tax_rate, detailItem.total)"
                      :disabled="!form.invoice_tax_type || form.invoice_tax_type === 2"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <el-row style="margin-bottom: 5px">
              <el-button type="danger"
                         style="display: block"
                         size="mini"
                         icon="el-icon-delete"
                         @click="onDelItem(itemIndex)">删除
              </el-button>
            </el-row>
            <el-row>
              <el-button type="primary"
                         size="mini"
                         style="display: block"
                         @click="uploadReport(itemIndex)">上传项目报告
                <i class="el-icon-upload-success el-icon-circle-check"
                   v-if="detailItem.uploaded"></i>
              </el-button>
            </el-row>
          </el-col>
        </el-row>
      </div>

      <div style="margin:30px 0 0 0;">
        <el-row>
          <el-col :span="4"
                  :offset="10"
                  class="col-center">未税金额总计：{{ symbol }} {{ untaxed_total_amount | seperateThousandsToFixed(2) }}
          </el-col>
          <el-col :span="3"
                  class="col-center">税额合计：{{ symbol }} {{ tax_total_amount | seperateThousandsToFixed(2) }}
          </el-col>
          <el-col :span="4"
                  class="col-center">价税合计总计：{{ symbol }} {{ taxed_total_amount | seperateThousandsToFixed(2) }}
          </el-col>
          <!-- <el-col :span="3" class="col-center"></el-col> -->
        </el-row>
      </div>

      <div v-if="isPreReceived">
        <el-tooltip class="item"
                    effect="dark"
                    content='在预收款开票申请时可以同时添加该预收款的抵扣申请，抵扣申请将于开票状态变为已签收时生效'
                    placement="right">
          <el-button type="danger"
                     size="mini"
                     @click="onAddDeductionDetail()"
                     style="margin-left:30px; margin-bottom: 30px">添加抵扣申请
          </el-button>
        </el-tooltip>
        <el-row :hidden="form.deduction_detail.length === 0">
          <el-col :span="1" class="col-center">序号</el-col>
          <el-col :span="6" class="col-center">项目名称/编号</el-col>
          <el-col :span="6" class="col-center">抵扣含税金额</el-col>
        </el-row>
        <br/>
        <el-row v-for="(detailItem, itemIndex) in form.deduction_detail"
                :key="itemIndex"
                class="invoice-row"
                style="margin-top:5px">
          <!--序号-->
          <el-col style="text-align: center"
                  :span="1">
            {{ itemIndex + 1 }}
          </el-col>
          <!--项目名称/编号-->
          <el-col :span="6">
            <remote-select
              :disabled="isDeductionItemDisabled(detailItem) || !form.customerid"
              class="width-max"
              clearable
              id-key="number"
              label-key="name"
              value-key="id"
              placeholder="请输入项目名称/编号搜索"
              v-model="detailItem.project_id"
              :query-request="(_)=>getProjectTable(Object.assign({status: statusEnum.ACHIEVEMENT, customerid: form.customerid}, _))"
              :find-request="getProjectDetail">
            </remote-select>
          </el-col>
          <!--抵扣含税金额-->
          <el-col :span="6"
                  style="text-align:center">
            <el-input v-model="detailItem.deduction_amount"
                      :disabled="isDeductionItemDisabled(detailItem)"
                      placeholder="请输入抵扣含税金额"
            ></el-input>
          </el-col>
          <el-col :span="5">
            <el-upload
              :disabled="isDeductionItemDisabled(detailItem)"
              class="upload-demo"
              action=""
              :auto-upload="false"
              :on-change="(file, fileList) => {onChangeFile(file, fileList, form.deduction_detail[itemIndex].attached_file)}"
              :before-remove="(file, fileList) => {beforeRemove(file, fileList, form.deduction_detail[itemIndex].attached_file)}"
              multiple
              :limit="20"
              :on-exceed="(file, fileList) => {handleExceed(file, fileList, 20)}"
              :file-list="form.deduction_detail[itemIndex].attached_file"
              ref="upload"
              accept=".jpg, .jpeg, .png, .pdf, .eml"
            >
              <el-tooltip class="item"
                          effect="dark"
                          content="只能上传PNG/JPG/PDF/EML文件，允许上传多张"
                          placement="right">
                <el-button size="small"
                           :disabled="isDeductionItemDisabled(detailItem)"
                           type="primary">上传抵扣审批附件
                </el-button>
              </el-tooltip>
            </el-upload>
          </el-col>
          <el-col :span=3>
            <el-row style="margin-bottom: 5px">
              <!--  只有待审批的抵扣条目允许删除  -->
              <el-button type="danger"
                         :disabled="isDeductionItemDisabled(detailItem)"
                         style="display: block"
                         size="mini"
                         icon="el-icon-delete"
                         @click="onDelDeductionItem(itemIndex)">删除
              </el-button>
            </el-row>
          </el-col>
        </el-row>

      </div>

      <div style="margin:0 auto; text-align:center; margin-top: 70px">
        <el-button @click="$router.push({name: '开票管理'})">取消</el-button>
        <el-button type="primary"
                   @click="onSubmit">保存
        </el-button>
      </div>
    </layout-panel>
    </template>
    <sj-upload-modal
      @uploaded="onUploadedReport"
      ref="uploadReport"
      :validate-file="true"
      :files="reportFiles"
      :showClearBtn="false"
      file-extension="zip"
      :file-max-size="100 * 1024 * 1024"
      request="uploadReportFile"
      tip="若文件大于100M，请以网盘链接的形式，添加压缩文件上传"
      title="上传项目报告"></sj-upload-modal>
  </div>
</template>

<script>
import SjUploadModal from '@/components/sj-upload-modal'
import ErrorPanel from '@components/ErrorPanel.vue'
import selectRemote from '@core/mixins/selectRemote'
import { regType } from '@utils/regExp'
import currency from 'currency.js'
import { formRules } from '../invoice-apply.rules.js'

const RMB = value => currency(value)

export default {
  mixins: [selectRemote],
  components: {SjUploadModal, ErrorPanel},
  data () {
    return {
      id: 0,
      showErrorMsg: true,
      detailErrorMsg: '',
      adminInfo: {},
      fullPaymentCompanyList: {},
      subjectErrorMessage: '',
      multipleLimit: 30,
      fileList: [],
      deductionFileList: [],
      formRules,
      selectLoading: false,
      customerItems: [],
      adminuserItems: [],
      projectItems: [],
      receiptOptions: [],
      form: {
        name: '',
        receipt_info_id: null,
        pay_condition_id: null,
        customerid: '',
        issued_type: 1, // 默认值:常规发票
        desc: '',
        type: 4, // 默认值：电子发票(增值税专用发票)
        subject: '',
        currency_type: 1, // 默认值：人民币
        bd: '',
        bu_approver: '',
        cc: [],
        po_number: '',
        memo: '',
        invoice_tax_type: null,
        invoice_remark: '',
        attached_file: [],
        tax_type: 1,
        detail: [this.defaultDetailObj()],
        deduction_detail: [],
      },
      receiptInfo: {
        customerid: null,
        company_name: null,
        tax_number: null,
        bank_info: null,
        address_phone: null,
      },
      receiptInfoList: [],
      symbol: '￥',
      availableSubjects: [],
      costTypeOptions: [],
      collectConditionOptions: [],
      reportFiles: [],
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.invoiceApply.options,
      statusEnum: state => state.customerProjectcost.statusEnum,
      user: state => state.login.user,
    }),
    taxed_total_amount: {
      get () {
        let taxedTotalAmount = 0
        for (let i = 0; i < this.form.detail.length; i++) {
          taxedTotalAmount = taxedTotalAmount + Number(this.form.detail[i].total)
        }
        return _.round(taxedTotalAmount, 2)// taxedTotalAmount.toFixed(2)
      }
    },
    tax_total_amount () {
      return this.form.detail.map(item => {
        return item.total - item.untaxed_amount
      }).reduce((total, current) => {
        return total + current
      }, 0)
    },
    untaxed_total_amount: {
      get () {
        let untaxedTotalAmount = 0
        for (let i = 0; i < this.form.detail.length; i++) {
          untaxedTotalAmount = untaxedTotalAmount + Number(this.form.detail[i].untaxed_amount)
        }
        return _.round(untaxedTotalAmount, 2)// untaxedTotalAmount.toFixed(2)
      },
    },
    isPreReceived () {
      return this.form.issued_type === 2
    }
  },
  watch: {
    'form.receipt_info_id': function (newValue, oldValue) {
      // 判断 receipt_info_id 是否发生了变化，减少对接口无意义的调用
      if (this.form.receipt_info_id && newValue * 1 !== oldValue * 1) {
        this.getReceiptInfo()
        this.setPayConditions()
      }
    },
    'form.currency_type': function () {
      this.options.currency_type.forEach((option) => {
        if (option.value === this.form.currency_type) {
          this.symbol = option.symbol
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  created () {},
  mounted () {},
  methods: {
    ...Vuex.mapActions(['getCustomerTable', 'getPlatformUsersIndex', 'getProjectTable', 'getCustomerDetail',
      'getProjectDetail', 'getPlatformUsersDetail', 'getReceiptVirtualProjectTable',
      'getReceiptVirtualProjectDetail'
    ]),
    async onLoad () {
      await this.getMeDetail(this.user.id)
      if (this.showErrorMsg) return

      await this.getFinCenterConfigs()
      if (this.showErrorMsg) return

      this.setInvoiceNameOption()
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      } else {
        this.setConfig()
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setConfig () {
      request.common('getInvoiceApplyDefaultConfig', {}).then(({data}) => {
        this.form.cc = data.cc.map((item) => item * 1)
      })
    },
    getMeDetail (id) {
      return this.getPlatformUsersDetail({id}).then(({data}) => {
        if (!Array.isArray(data.company_ids) || data.company_ids.length === 0) {
          this.detailErrorMsg = '您的账号尚未配置所属公司主体，无法使用开票申请/修改功能。请联系管理员为您配置所属公司主体'
          this.showErrorMsg = true
        } else {
          this.adminInfo = data
          this.adminInfo.company_ids = data.company_ids.map(item => item * 1)
          this.showErrorMsg = false
        }
      }).catch((error) => {
        this.detailErrorMsg = '获取用户信息失败' + error
        this.showErrorMsg = true
      })
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        const allSource = data.payment_apply_our_company_source.map(item => ({...item, id: item.id * 1}))
        this.fullPaymentCompanyList = allSource.reduce((acc, item) => {
          acc[item.id] = item
          return acc
        }, {})
        this.availableSubjects = allSource.filter(item => !item.is_disabled && this.adminInfo.company_ids.includes(item.id))
        if (this.availableSubjects.length === 0) {
          this.detailErrorMsg = '您的账号配置的所属公司主体已被全部禁用，无法使用开票申请/修改功能。请联系管理员启用对应公司主体，或为您重新分配可用的公司主体'
          this.showErrorMsg = true
        } else {
          this.showErrorMsg = false
        }
      })
    },
    setInvoiceNameOption () {
      return request.common('allEnabledInvoiceName').then(({data}) => {
        this.costTypeOptions = data
      })
    },
    getRemoteSelectVirtualProjectInfo ({id}) {
      if (!this.form.customerid) {
        return Promise.resolve({data: []})
      }
      return new Promise((resolve, reject) => {
        request.common('getReceiptVirtualProjectDetail', {id: id, customerid: this.form.customerid}).then(({data}) => {
          if (data) {
            resolve({
              data
            })
          } else {}
        })
      })
    },
    setForm (id) {
      request.page('getInvoiceApplyDetail', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
        // 校验 subject 是否在 fullPaymentCompanyList 中且未被禁用，以及在当前账号配置的所属开票主体中
        this.subjectErrorMessage = ''
        if (this.form.subject) {
          const company = this.fullPaymentCompanyList[this.form.subject]
          if (!company || company.is_disabled) {
            this.subjectErrorMessage = `当前开票主体【${company ? company.name : ''}】已被禁用，请重新选择`
            this.form.subject = null
          } else if (!this.adminInfo.company_ids.includes(this.form.subject)) {
            // 如果开票主体不在当前账号配置的所属开票主体中，则清空选择并设置提示信息
            this.subjectErrorMessage = `当前开票主体【${company ? company.name : ''}】不在您账号的所属开票主体中，请重新选择`
            this.form.subject = null
          }
        }
        // 修复抄送人只显示 id 的bug
        this.form.cc = this.form.cc.map((value) => value * 1)
        // this.form.detail = this.form.detail.map((value) => {
        //   value.virtual_project_id = value.virtual_project_id
        //   return value
        // })
        // 修复客户名称只显示 id 的bug
        this.form.customerid = String(this.form.customerid)
        // 获取开票信息
        // 如果有receipt id 就获取  没有就拿默认的
        if (data.receipt_info_id > 0) {
          this.getReceiptInfo()
        } else {
          this.onChangeCustomerId()
        }
        for (let i = 0; i < this.form.detail.length; i++) {
          // 获取项目成本和项目预算
          if (this.form.detail[i].projectid) {
            this.form.detail[i].tax_type = this.form.detail[i].tax_type ? this.form.detail[i].tax_type : ''
            request.common('getInvoiceProjectFinance', {id: this.form.detail[i].projectid}).then((res) => {
              this.$set(this.form.detail[i], 'budget', _.round(Number(res.data.total_budget), 2)) // Number(res.data.budget).toFixed(2)
              this.$set(this.form.detail[i], 'cost', _.round(Number(res.data.cost), 2)) // Number(res.data.cost).toFixed(2)
              if (res.data.complete_rate > 0) {
                this.$set(this.form.detail[i], 'complete_rate', _.round(Number(res.data.complete_rate), 2)) // Number(res.data.complete_rate).toFixed(2)
                this.form.detail[i].modifyRate = false
              } else {
                this.form.detail[i].modifyRate = true
              }
            })
            // 修正修改开票信息时，项目名称/编号 显示id的bug
            this.form.detail[i].projectid = String(this.form.detail[i].projectid)
          }
        }
        this.fileList = this.form.attached_file

        // 修复抵扣项目编号 id 问题
        this.form.deduction_detail.forEach(item => {
          item.project_id = String(item.project_id)
        })

        // 剔除禁用的 主体 和 开票名称
        const availableSubjects = this.availableSubjects.map(item => item.id)
        if (!availableSubjects.includes(this.form.subject)) {
          this.form.subject = null
        }

        const costTypeOptions = this.costTypeOptions.map(item => item.id)
        this.form.detail.forEach(detailItem => {
          if (!costTypeOptions.includes(detailItem.cost_type)) {
            detailItem.cost_type = null
          }
        })
      })
    },
    changeIssuedType () {
      if (this.isPreReceived) {
        this.form.detail = [this.defaultDetailObj()]
        if (this.form.customerid) {
          this.form.detail[0].virtual_project_id = 0
        }
      }
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.checkSubmit()) return
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    getReceiptInfo () {
      if (this.form.customerid > 0) {
        let id = this.form.customerid
        request.page('getCustomerReceiptOptions', {customerid: id}).then(({data}) => {
          this.receiptOptions = data
        })
      }
      request.page('getReceiptInfo', {id: this.form.receipt_info_id}).then(({data}) => {
        if (data.deleted_at === null) {
          filter.setLoop(this.receiptInfo, data)
        } else {
          this.form.receipt_info_id = null
        }
      })
    },
    setPayConditions () {
      request.page('getReceiptInfoCollectList', {id: this.form.receipt_info_id}).then(({data}) => {
        this.collectConditionOptions = data.filter(item => { return item.is_disabled < 1 })
      })
    },
    create () {
      request.common('createInvoiceApplyData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.onReload()
        }, () => {
          this.$router.back()
        })
      })
    },
    update (id) {
      request.common('updateInvoiceApplyData', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.back()
        })
      })
    },
    adminuserRemoteMethod (query) {
      if (query !== '') {
        this.selectLoading = true
        setTimeout(() => {
          this.getPlatformUsersIndex({name: query}).then((response) => {
            this.adminuserItems = response.data.data
          }).finally(() => {
            this.selectLoading = false
          })
        }, 200)
      } else {
        this.rawCustomerItems = []
      }
    },
    onChangeCustomerId () {
      this.receiptOptions = []
      this.collectConditionOptions = []
      this.form.pay_condition_id = null
      if (this.form.customerid > 0) {
        let id = this.form.customerid
        request.page('getCustomerReceiptOptions', {customerid: id}).then(({data}) => {
          this.receiptOptions = data
          this.resetReceiptInfo()
          data.forEach((option) => {
            if (option.default === 1) {
              this.form.receipt_info_id = option.value
            }
          })
        })
      } else {
        this.form.receipt_info_id = null
        this.receiptInfo = {
          customerid: null,
          company_name: null,
          tax_number: null,
          bank_info: null,
          address_phone: null,
        }
      }
      // 清空所选项目
      for (let i = 0; i < this.form.detail.length; i++) {
        // 获取项目成本和项目预算
        if (this.form.detail[i].projectid) {
          this.form.detail[i].projectid = ''
        }
      }
      // 清空所选项目
      for (let i = 0; i < this.form.deduction_detail.length; i++) {
        this.form.deduction_detail[i].project_id = ''
      }
      if (this.isPreReceived) {
        this.$refs['virtual'][0].emptyOptions()
        this.form.detail[0].virtual_project_id = 0
        this.$refs['virtual'][0].setOption('0')
      }
    },
    resetReceiptInfo () {
      this.form.receipt_info_id = null
      this.receiptInfo = {
        customerid: null,
        company_name: null,
        tax_number: null,
        bank_info: null,
        address_phone: null,
      }
    },
    onAddDetail () {
      this.form.detail.push(this.defaultDetailObj())
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    onChangeFile (file, fileList, formField) {
      let isLt5M = file.raw.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.$message.error('文件内容必须小于5MB!')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      this.onUploadFile(file.raw, fileList, formField)
    },
    onUploadFile (file, fileList, formField) {
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadInvoiceApplyFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type
        if ((file.name.substr(-5).toLowerCase() === '.jpeg') || (file.name.substr(-4).toLowerCase() === '.jpg') || (file.name.substr(-4).toLowerCase() === '.png')) {
          type = 'pic'
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf'
        } else if (file.name.substr(-4).toLowerCase() === '.eml' || (file.name.substr(-5).toLowerCase() === '.html') || (file.name.substr(-4).toLowerCase() === '.htm')) {
          type = 'eml'
        } else if (file.name.substr(-5).toLowerCase() === '.docx' || (file.name.substr(-5).toLowerCase() === '.xlsx') || (file.name.substr(-4).toLowerCase() === '.doc')) {
          type = 'office'
        } else if (file.name.substr(-4).toLowerCase() === '.zip') {
          type = 'zip'
        }
        if (index > -1) {
          fileList[index].status = 'success'
          formField[index] = {name: file.name, url: data, type: type}
        }
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
      })
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
    onDelItem (index) {
      if (this.form.detail.length === 1) {
        this.$alert('开票项目信息最少为一个', '提示', {
          type: 'error',
        })
      } else {
        this.form.detail.splice(index, 1)
      }
    },
    onAddDeductionDetail () {
      let params = {
        project_id: '',
        deduction_amount: 0,
        attached_file: [],
      }
      this.form.deduction_detail.push(params)
    },
    onDelDeductionItem (index) {
      this.form.deduction_detail.splice(index, 1)
    },
    isDeductionItemDisabled (detailItem) {
      // 抵扣条目的状态见 deduction_detail_status 数组,条目处于非待审核状态时，禁用编辑删除功能
      return detailItem.status && detailItem.status * 1 !== 1
    },
    changeProject (projectid, index) {
      if (projectid) {
        request.common('getInvoiceProjectFinance', {id: projectid}).then((res) => {
          this.form.detail[index].budget = _.round(Number(res.data.total_budget), 2)// Number(res.data.budget).toFixed(2)
          this.form.detail[index].cost = _.round(Number(res.data.cost), 2)// Number(res.data.cost).toFixed(2)
          if (res.data.complete_rate > 0) {
            this.form.detail[index].complete_rate = _.round(Number(res.data.complete_rate), 2)// Number(res.data.complete_rate).toFixed(2)
            this.form.detail[index].modifyRate = false
          } else {
            this.form.detail[index].complete_rate = ''
            this.form.detail[index].modifyRate = true
          }
        })
      } else {
        this.form.detail[index].budget = 0
        this.form.detail[index].cost = 0
        this.form.detail[index].complete_rate = ''
        this.form.detail[index].modifyRate = true
      }
    },
    // 同步税率，使用选择的开票名称税率
    changeCostType (id, index) {
      const invoiceName = this.costTypeOptions.find((item) => { return item.id === id })
      this.form.detail[index].tax_rate = invoiceName.tax_rate
      if (this.form.invoice_tax_type === 1) {
        this.computeUntaxedAmount(index, invoiceName.tax_rate, this.form.detail[index].total)
      }
      if (this.form.invoice_tax_type === 2) {
        this.computeTotal(index, invoiceName.tax_rate, this.form.detail[index].untaxed_amount)
      }
    },
    /* 验证项目内开票的信息 */
    checkSubmit () {
      if (!this.adminInfo.company_ids.includes(this.form.subject)) {
        this.$message.error('所选开票主体不在您账号配置的所属开票主体中')
        return false
      }

      if (this.isPreReceived && this.form.detail.length > 1) {
        this.$message.error('预收款发票仅允许添加一条开票项目信息')
        return false
      }
      if (this.taxed_total_amount * 1 === 0) {
        this.$message.error('价税合计总计金额不能为 0')
        return false
      }
      for (let i = 0; i < this.form.detail.length; i++) {
        if (!this.form.detail[i].type) {
          this.$message.error('请输入开票类型')
          return false
        }
        // 常规发票必须选择项目id
        if (!this.isPreReceived && !this.form.detail[i].projectid) {
          this.$message.error('请选择项目')
          return false
        }
        // 预收款发票必须选择虚拟项目id
        if (this.isPreReceived && !_.isNumber(this.form.detail[i].virtual_project_id)) {
          this.$message.error('请选择项目')
          return false
        }
        if (!Number.isInteger(this.form.detail[i].cost_type)) {
          this.$message.error('请输入开票名称')
          return false
        }

        if (!Number.isInteger(this.form.detail[i].tax_type)) {
          this.$message.error('请选择含税未税金额')
          return false
        }

        if (!Number.isInteger(this.form.detail[i].tax_rate)) {
          this.$message.error('请输入正确的税率')
          return false
        }

        if (!regType('money').test(Math.abs(this.form.detail[i].untaxed_amount))) {
          this.$message.error(`第${i + 1}行,请输入正确的未税金额数字,小数部分至多保留两位小数`)
          return false
        }

        if (!regType('money').test(Math.abs(this.form.detail[i].total))) {
          this.$message.error(`第${i + 1}行,请输入正确的价税合计金额数字,小数部分至多保留两位小数`)
          return false
        }

        if (this.taxed_total_amount * this.form.detail[i].total < 0) {
          this.$message.error('开票详情中价税合计金额不得同时出现正负数据')
          return false
        }

        if (this.form.detail[i].complete_rate > 0 && !regType('money').test(this.form.detail[i].complete_rate)) {
          this.$message.error('请输入正确的项目完成率')
          return false
        }
      }
      let deductionTaxedAmountTotal = 0
      for (let i = 0; i < this.form.deduction_detail.length; i++) {
        if (!this.form.deduction_detail[i].project_id) {
          this.$message.error('请选择抵扣申请项目')
          return false
        }
        if (!regType('money').test(Math.abs(this.form.deduction_detail[i].deduction_amount)) || Math.abs(this.form.deduction_detail[i].deduction_amount) === 0) {
          this.$message.error('请输入正确的抵扣申请含税金额')
          return false
        }
        if (this.form.deduction_detail[i].attached_file.length < 1) {
          this.$message.error('请上传抵扣申请附件')
          return false
        }
        if (!this.form.deduction_detail[i].status || [1, 2, 3].includes(this.form.deduction_detail[i].status * 1)) {
          deductionTaxedAmountTotal += Number(this.form.deduction_detail[i].deduction_amount)
        }
        delete this.form.deduction_detail[i].log
      }
      if (Math.abs(deductionTaxedAmountTotal) > Math.abs(this.taxed_total_amount)) {
        this.$message.error('抵扣金额总和不得大于价税合计总计金额')
        return false
      }

      // 未税金额合计>=1万元，自动在抄送人增加管理员Sam Huang/59
      if (this.untaxed_total_amount >= 10000) {
        this.form.cc.push(59)
      }
      // 开票主体为小零，所有开票抄送Irene/65，未税金额>=10W 时追加Fenix/1
      if (this.form.subject === 1) {
        this.form.cc.push(65)
        this.form.cc.push(753) // 抄送追加 ken zhang
        // 2021-07-23 取消追加抄送人 Fenix/1
        // if (this.untaxed_total_amount >= 100000) {
        //  this.form.cc.push(1)
        // }
      }

      this.form.cc = _.uniq(this.form.cc)

      if (this.strLengthCount(this.form.invoice_remark) > 184) {
        this.$message.error('百旺开票服务限制，发票备注不得大于184个字符, 汉字和全角字符占用2个长度')
        return false
      }

      return true
    },
    computeTotal (index, taxRate, untaxedAmount) {
      let totalAmount = RMB(0.01).multiply(RMB(taxRate)).add(1).multiply(untaxedAmount)
      this.form.detail[index].total = totalAmount.value
      this.form.detail[index].tax_amount = totalAmount.subtract(RMB(untaxedAmount))
    },
    computeUntaxedAmount (index, taxRate, total) {
      let untaxedAmount = RMB(total).divide(RMB(0.01).multiply(RMB(taxRate)).add(1))
      this.form.detail[index].untaxed_amount = untaxedAmount.value
      this.form.detail[index].tax_amount = RMB(total).subtract(untaxedAmount).value
    },
    onUploadedReport (report, index) {
      this.$set(this.form.detail[index], 'uploaded', !!report)
      this.$set(this.form.detail[index], 'report', report)
    },
    uploadReport (itemIndex) {
      this.$refs.uploadReport.open(itemIndex)
      const files = this.form.detail[itemIndex].report ? [this.form.detail[itemIndex].report] : []
      this.reportFiles = files
    },
    strLengthCount: function (str) {
      // eslint-disable-next-line no-control-regex
      const banjiao = this.countArr(str.match(/[\u0000-\u00ff]/g))
      const quanjiao = this.countArr(str.match(/[\uff00-\uffff]/g))
      const chinese = this.countArr(str.match(/[\u4e00-\u9fa5]/g))
      return banjiao + (quanjiao + chinese) * 2
    },
    countArr (arr) {
      return arr == null ? 0 : arr.length
    },
    defaultDetailObj () {
      return {
        id: 0,
        type: '市场调查',
        projectid: '',
        virtual_project_id: '',
        do_number: '',
        memo: '',
        complete_rate: '',
        modifyRate: true,
        budget: 0,
        spec: '',
        unit: '',
        quantity: '',
        cost: 0,
        cost_type: null,
        untaxed_amount: 0,
        tax_rate: 6,
        total: 0,
        tax_amount: 0,
        report: null,
        uploaded: false,
        tax_type: 1,
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.col-center {
  text-align: center
}

.receipt-info {
  display: block;
  margin-bottom: 10px;
}

.receipt-info-text {
  margin-right: 8px;
  font-weight: bold;
}

.receipt-info-block {
  width: 470px;
  margin-bottom: 30px;
  margin-left: 70px;
  border-radius: 5px;
  border: 2px solid transparent;
  background-clip: padding-box;
  background-color: rgba(128, 128, 128, 0.1);
  padding: 5px 10px;
}

.invoice-row {
  min-height: 80px;
}

.invoice-row .el-col {
  line-height: 40px;
  text-align: center;
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/InvoiceApplyForm.vue